
import * as React from "react"
import { SettingsPageWrapper } from "@/modules/settings/components/SettingsPageWrapper"

export const PreLoader = () => {
  return (
    <SettingsPageWrapper isPending />
  )
}
